import { POST } from "../../index";

export const selectCarOrder = (param) => POST("/v1/BigDataAnalysisController/selectCarOrder", param);
export const selectCarOrderList = (param) => POST("/v1/BigDataAnalysisController/selectCarOrderList", param);

export const SelectTodayWorkTimePage = (param) => POST("/v1/BigDataAnalysisController/useDate/SelectTodayWorkTimePage", param);
export const SelectUseRatePage = (param) => POST("/v1/BigDataAnalysisController/useDate/SelectUseRatePage", param);
export const selectDailyUseRate = (param) => POST("/v1/BigDataAnalysisController/useDate/selectDailyUseRate", param);

export const SelectTodayProblemCountPage = (param) => POST("/v1/BigDataAnalysisController/fault/SelectTodayProblemCountPage", param);
export const queryFaultCountPeriod = (param) => POST("/v1/BigDataAnalysisController/fault/queryFaultCountPeriod", param);
export const queryFaultCountPeriodRate = (param) => POST("/v1/BigDataAnalysisController/fault/queryFaultCountPeriodRate", param);
export const queryFaultPageByCar = (param) => POST("/v1/BigDataAnalysisController/fault/queryFaultPageByCar", param);
export const selectAllCarAndWorkTime = (param) => POST("/v1/BigDataAnalysisController/useDate/selectAllCarAndWorkTime", param);

export const queryCarDayWorkTime = (param) => POST("/v1/CarDataAnalysisController/queryCarDayWorkTime", param);

export const selectCarWorkList = (param) => POST("/v1/CarDataAnalysisController/selectCarWorkList", param);